/* eslint-disable */
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { InputSwitch } from 'primereact/inputswitch';
import SavedButtonIcon from '../../assets/images/saved-icon.jpg';
import ExcelButtonIcon from '../../assets/images/excel-icon.jpg';
import HomeScreenImage from '../../assets/images/home-image.jpg';
import HomeScreenPicture from '../../assets/images/home-image1.png';
import './Home.scss';
import FilteredHome from './FilteredHome';
import AGGrid from './AGGrid';

interface HomeProps {
  filterResult?: {
    year: number | null;
    customer: number | null;
    category: number | null;
    brand: number | null;
    isSummaryView: boolean;
  } | null;
}

const Home: React.FC<HomeProps> = ({ filterResult }) => {
  const [isMonthly, setIsMonthly] = useState(true);
  const [detailedView, setDetailedView] = useState(true);

  if (filterResult) {
    // return (
    //   <div className="home-container">
    //     <div className="filter-result-box">
    //       <h3>Filtered Data</h3>
    //       <ul>
    //         <li><strong>Year:</strong> {filterResult.year || '-'}</li>
    //         <li><strong>Customer:</strong> {filterResult.customer || '-'}</li>
    //         <li><strong>Category:</strong> {filterResult.category || '-'}</li>
    //         <li><strong>Brand:</strong> {filterResult.brand || '-'}</li>
    //       </ul>
    //     </div>
    //   </div>
    // );
    return <AGGrid filterResult={filterResult} />;
  }

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="view-toggle m-2 mb-4 flex align-items-center justify-content-between">
          <span className="disabled-label" style={{ marginRight: '0.5rem' }}>Monthly</span>
          <InputSwitch checked={detailedView} onChange={(e) => setDetailedView(e.value!)} disabled />
          <span className="disabled-label" style={{ marginLeft: '0.5rem' }}>Quarterly</span>
        </div>
        <div className="action-buttons">
          <Button
            label="Save Changes"
            icon={<img src={SavedButtonIcon} alt="Save" className="btn-icon" />}
            className="p-button-outlined p-button-secondary"
            style={{ color: '#a6a6a6', border: 'solid 1px #a6a6a6', cursor: 'not-allowed' }}
          />
          <Button
            label="Export Excel"
            icon={<img src={ExcelButtonIcon} alt="Excel" className="btn-icon" />}
            className="p-button-outlined p-button-secondary"
            style={{ color: '#a6a6a6', border: 'solid 1px #a6a6a6', cursor: 'not-allowed' }}
          />
        </div>
      </div>

      <div className="home-body">
        <img src={HomeScreenPicture} alt="Home Illustration" className="home-illustration" />

      </div>
    </div>
  );
};

export default Home;
